<template>
  <div>
    <section v-if="currentStage" class="order-confirmation-line"></section>
    <section v-else class="order-confirmation-ellipsis-dot__wrapper">
      <span class="order-confirmation-ellipsis-dot"></span>
      <span class="order-confirmation-ellipsis-dot"></span>
      <span class="order-confirmation-ellipsis-dot"></span>
      <span class="order-confirmation-ellipsis-dot"></span>
      <span class="order-confirmation-ellipsis-dot"></span>
    </section>
  </div>

</template>

<script>
export default {
  name: "ProgressIndicator",
  props: { currentStage: Boolean }
};
</script>

<style lang="scss" scoped>
.order-confirmation {
  &-ellipsis-dot {
    &__wrapper {
      display: flex;
    }

    width: 5.3px;
    height: 5.3px;
    background: #dbdbdb;
    margin-left: 3.5px;
    border-radius: 50%;

    &:last-child {
      margin-right: 3.5px;
    }
  }

  &-line {
    width: 40px;
    background: var(--v-secondary-base);
    height: 6px;
  }
}

</style>
